import React from "react";
import { useTranslation } from "react-i18next";
import { styles } from "../styles/layout";

export default function LanguageSwitcher({
  onChange,
  activeLanguage,
  containerStyle = styles.flags,
  buttonStyle = styles.flagBtn,
  flagWidth = 32,
  flagHeight = 21,
}) {
  const { i18n } = useTranslation();
  const currentLanguage = (activeLanguage || i18n.language || "pt").slice(0, 2).toLowerCase();
  const getFlagButtonStyle = (lang) => ({
    ...buttonStyle,
    opacity: currentLanguage === lang ? 1 : 0.45,
    filter: currentLanguage === lang ? "none" : "saturate(0.55)",
    transition: "opacity 0.2s ease, filter 0.2s ease",
  });

  return (
    <div style={containerStyle}>
      <button onClick={() => onChange("pt")} style={getFlagButtonStyle("pt")} aria-label="Portugues">
        <img
          src="https://purecatamphetamine.github.io/country-flag-icons/3x2/BR.svg"
          alt="Portugues"
          width={flagWidth}
          height={flagHeight}
          loading="lazy"
        />
      </button>
      <button onClick={() => onChange("en")} style={getFlagButtonStyle("en")} aria-label="English">
        <img
          src="https://purecatamphetamine.github.io/country-flag-icons/3x2/GB.svg"
          alt="English"
          width={flagWidth}
          height={flagHeight}
          loading="lazy"
        />
      </button>
      <button onClick={() => onChange("es")} style={getFlagButtonStyle("es")} aria-label="Espanol">
        <img
          src="https://purecatamphetamine.github.io/country-flag-icons/3x2/ES.svg"
          alt="Espanol"
          width={flagWidth}
          height={flagHeight}
          loading="lazy"
        />
      </button>
    </div>
  );
}
